import {
  SR_API_ACTION_GET_USER_ASSIGNED_CUSTOMER_SUPPORT_PHONE_NUMBER,
} from 'api/actionTypes';

export default async function getCustomerSupportPhoneNumber({ state, apiClient }, { userId }) {
  if (state.get(['currentUser', 'customerSupportPhone'])) {
    return;
  }

  await apiClient.postWithState({
    action: SR_API_ACTION_GET_USER_ASSIGNED_CUSTOMER_SUPPORT_PHONE_NUMBER,
    state: state,
    payload: {
      userId,
    },
    onSuccess(phone) {
      if (phone) {
        state.set(['currentUser', 'customerSupportPhone'], phone);
      }
    },
  });
}
